export default "__VITE_ASSET__BRCiZCEh__"